<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'chart-pie', path: '/dashboard'}"/>
        <sidebar-item :link="{name: 'Packages', icon: 'archive'}">
          <sidebar-item :link="{name: 'Management', path: '/packages/management'}"/>
          <sidebar-item :link="{name: 'Keywords', path: '/packages/keywords'}"/>
        </sidebar-item>
        <sidebar-item :link="{name: 'Users', icon: 'users', path: '/users/management'}"/>
        <sidebar-item :link="{name: 'Organizations', icon: 'building', path: '/organizations/management'}"/>
        <sidebar-item :link="{name: 'Configuration', icon: 'cogs', path: '/config/application'}"/>
        <sidebar-item :link="{name: 'System Information', icon: 'server', path: '/config/sysinfo'}"/>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./DashboardUtils/TopNavbar.vue";
import ContentFooter from "./DashboardUtils/ContentFooter.vue";
import DashboardContent from "./DashboardUtils/Content.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};

</script>
<style lang="scss" scoped>
  .vue-notifyjs.notifications {
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }

    .list-item {
      display: inline-block;
      margin-right: 10px;

    }

    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }

    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }

    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>
